import React, { FunctionComponent } from 'react';

interface IParagraph {
  html?: string | null;
  className?: string | null;
  style?: any;
}

const Paragraph: FunctionComponent<IParagraph> = ({ html, style, className }) => {
  return html ? (
    <div className={` ${className || ''}`} dangerouslySetInnerHTML={{ __html: html }} style={style} />
  ) : null;
};

export default Paragraph;
